/**
 * Contratti Page - Page Shell
 * Imports ContrattoTemplateList from features/legal
 * Data fetched via React Query hooks
 */

import { ContrattoTemplateList } from "@/features/legal";

export default function Contratti() {
  return <ContrattoTemplateList />;
}
